import { render, staticRenderFns } from "./news_school.vue?vue&type=template&id=14ee207e&scoped=true&"
import script from "./news_school.vue?vue&type=script&lang=js&"
export * from "./news_school.vue?vue&type=script&lang=js&"
import style0 from "./news_school.vue?vue&type=style&index=0&id=14ee207e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ee207e",
  null
  
)

export default component.exports